import React from 'react';
import { CurrencyContext } from './context';

export const useCurrency = () => React.useContext(CurrencyContext);
